<!-- Annotation Label Form -->
@if (annotationLabelForm) {
  <medsurf-design-form-control-form
    [formGroup]="annotationLabelForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <!-- Editor -->
    <medsurf-design-form-control-input-textarea [control]="annotationLabelForm.controls.text"
      [label]="'global.name'"
      [class]="'w-full'"
    (valueChange)="onSubmit()"></medsurf-design-form-control-input-textarea>
  </medsurf-design-form-control-form>
}